// extracted by mini-css-extract-plugin
module.exports = {"button":"_1NqzCLEz15","message-prev":"_1edqEUuV7Y","messagePrev":"_1edqEUuV7Y"};
    if(module.hot) {
      // 1614934762172
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  